import { batch } from 'react-redux';

// project imports
import gestopAPI from 'utils/gestopAPI';
import { dispatch } from 'store/index';
import { errorProcessor } from 'utils/processors';
import { tplFollowUpActions } from './slice';
import capabilities from './capabilities';

export const ApiTplFollowUpsGetCollection = async ({
    filters = [],
    orderBy = [],
    groupBy = [],
    page = 1,
    limit = 10,
    includeSafeDeleted = false,
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(tplFollowUpActions.startLoading());
    }

    await gestopAPI
        .post('tplmgmt/followups/list', { filters, orderBy, groupBy, page, limit, includeSafeDeleted }, config)
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(tplFollowUpActions.setList(response?.data?.list));
                    dispatch(tplFollowUpActions.setCount(response?.data?.count));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(tplFollowUpActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data?.list);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(tplFollowUpActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(tplFollowUpActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiTplFollowUpsCountCollection = async ({
    filters = [],
    includeSafeDeleted = false,
    successCallback = () => {},
    errorCallback = () => {},
    config = {}
}) => {
    await gestopAPI
        .post('tplmgmt/followups/count', { filters, includeSafeDeleted }, config)
        .then((response) => {
            if (typeof successCallback === 'function') {
                successCallback(response?.data?.count);
            }
        })
        .catch((error) => {
            const errorMsg = errorProcessor(error?.response?.data);

            if (typeof errorCallback === 'function') {
                errorCallback(errorMsg);
            }
        });
};

export const ApiTplFollowUpsPostCollection = async ({
    data = {},
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(tplFollowUpActions.startLoading());
    }

    await gestopAPI
        .post('tplmgmt/followups', data, config)
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(tplFollowUpActions.insertItems(response?.data));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(tplFollowUpActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(tplFollowUpActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(tplFollowUpActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiTplFollowUpsDeleteCollection = async ({
    ids = [],
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(tplFollowUpActions.startLoading());
    }

    await gestopAPI
        .post('tplmgmt/followups/delete', ids, config)
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(tplFollowUpActions.deleteItems(response?.data));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(tplFollowUpActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(tplFollowUpActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(tplFollowUpActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiTplFollowUpsExportCollection = async ({
    exportType = 'allRows',
    format = 'pdf',
    columns = [],
    filters = [],
    orderBy = [],
    groupBy = [],
    successCallback = () => {},
    errorCallback = () => {},
    config = {}
}) => {
    if (capabilities.app.includes('exporter')) {
        dispatch(tplFollowUpActions.startExporting());
    }

    await gestopAPI
        .post('tplmgmt/followups/export', { exportType, format, columns, filters, orderBy, groupBy }, { ...config, responseType: 'blob' })
        .then((response) =>
            batch(() => {
                window.open(URL.createObjectURL(response?.data));

                if (capabilities.app.includes('exporter')) {
                    dispatch(tplFollowUpActions.stopExporting());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('exporter')) {
                    dispatch(tplFollowUpActions.stopExporting());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(tplFollowUpActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiTplFollowUpsPutItem = async ({
    id,
    data = {},
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(tplFollowUpActions.startLoading());
    }

    await gestopAPI
        .put(`tplmgmt/followups/${id}`, data, config)
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(tplFollowUpActions.updateItems(response?.data));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(tplFollowUpActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(tplFollowUpActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(tplFollowUpActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiTplFollowUpsPatchItem = async ({
    id,
    data = {},
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(tplFollowUpActions.startLoading());
    }

    await gestopAPI
        .patch(`tplmgmt/followups/${id}`, data, {
            ...config,
            headers: { ...config?.headers, 'Content-Type': 'application/merge-patch+json' } // Specific content type for PATCH requests
        })
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(tplFollowUpActions.updateItems(response?.data));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(tplFollowUpActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(tplFollowUpActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(tplFollowUpActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiTplFollowUpsDeleteItem = async ({
    id,
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(tplFollowUpActions.startLoading());
    }

    await gestopAPI
        .delete(`tplmgmt/followups/${id}`, config)
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(tplFollowUpActions.deleteItems(id));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(tplFollowUpActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(tplFollowUpActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(tplFollowUpActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiTplFollowUpsExportItem = async ({ id, successCallback = () => {}, errorCallback = () => {}, config = {} }) => {
    if (capabilities.app.includes('exporter')) {
        dispatch(tplFollowUpActions.startExporting());
    }

    await gestopAPI
        .get(`tplmgmt/followups/export/${id}`, { ...config, responseType: 'blob' })
        .then((response) =>
            batch(() => {
                window.open(URL.createObjectURL(response?.data));

                if (capabilities.app.includes('exporter')) {
                    dispatch(tplFollowUpActions.stopExporting());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('exporter')) {
                    dispatch(tplFollowUpActions.stopExporting());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(tplFollowUpActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiTplFollowUpsGetItem = async ({ id, successCallback = () => {}, errorCallback = () => {}, config = {} }) => {
    if (capabilities.app.includes('loader')) {
        dispatch(tplFollowUpActions.startLoading());
    }

    await gestopAPI
        .get(`tplmgmt/followups/${id}`, config)
        .then((response) =>
            batch(() => {
                if (capabilities.app.includes('loader')) {
                    dispatch(tplFollowUpActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(tplFollowUpActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(tplFollowUpActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};
